var map = {
	"./1.svg": 5558,
	"./19.svg": 6579,
	"./2.svg": 6805,
	"./20.svg": 8687,
	"./21.svg": 6110,
	"./22.svg": 285,
	"./23.svg": 9660,
	"./24.svg": 4291,
	"./25.svg": 6354,
	"./26.svg": 5041,
	"./27.svg": 2800,
	"./28.svg": 5719,
	"./29.svg": 8598,
	"./3.svg": 1172,
	"./30.svg": 6748,
	"./6.svg": 793,
	"./7.svg": 2872,
	"./8.svg": 1999,
	"./9.svg": 3070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9165;